const onlyInteger = value => {
  return value.replace(/[^\d]/gi, '');
}; //onlyInteger

const onlyIntegerNoLeadingZero = value => {
  return value.replace(/\D|^0+/g, '');
}; //onlyIntegerNoLeadingZero

export { onlyInteger, onlyIntegerNoLeadingZero };
